// Type dữ liệu trên manager
export default {
  CurrentData: 1, // ĐANG LÀM VIỆC
  NotData: 2, // KHÔNG LÀM VIỆC
  ErrorData: 3, // DỮ LIỆU LỖI
  Restoring: 4, // ĐANG PHỤC HỒI
  Backuping: 5, // ĐANG SAO LƯU
  CreateData: 6, // ĐANG TẠO DỮ LIỆU
  Converting: 7, // Đang chuyển đổi
  ConvertError: 8, // Chuyển đổi lỗi
  Storing: 12, // ĐANG LƯU TRỮ
  PendingProcess: 13
};
